import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app";

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
		// The register stays open all day on one page load; v11's default of one
		// session per page load would collapse a whole shift into one session
		Sentry.browserSessionIntegration({ lifecycle: "route" }),
	],
	tracesSampleRate: 1.0,
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 1.0,
	// v11 infers the user's IP address by default; keep the v10 behaviour
	dataCollection: { userInfo: false },
});

const root = document.getElementById("root");

if (root) {
	createRoot(root).render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}
